// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { createGlobalStyle } from 'styled-components';

export const GlobalStyled = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'SF Pro Display';

    &::-webkit-scrollbar-track {
      background-color: #000000;
      border-radius: 20px;
    }

    &::-webkit-scrollbar {
      width: 12px;
      height: 12px;
    }

    &::-webkit-scrollbar-thumb {
      -webkit-transition: all 0.3s ease;
      transition: all 0.3s ease;
      border-radius: 10px;
      background-color: #9E9EA3;
      border-width: 3px;
      border-style: solid;
      border-color: #000000;

      &:hover {
        border-width: 2px;
        background-color: darken(#000000, 5%);
      }
    }

    &::-webkit-scrollbar-button {
      display: none;
    }
  }

  button {
    cursor: pointer;
  }

  html,
  body,
  #root {
    font-family: 'SF Pro Display';
    font-weight: 400;
    background: #000000!important;
    color: #fff;
  }


  #root {
    overflow: hidden;
  }
`;
